import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  inputLabel: {
    marginBottom: 10,
  },
  interactionBlockContainer: {
    marginBottom: theme.spacing(5),
  },
  tooltipLabel: { marginLeft: theme.spacing(1) },
  tooltipRow: {
    marginBottom: theme.spacing(1),
  },
  filterContainer: {
    padding: `0 ${theme.spacing(1)}px ${theme.spacing(1)}px 0`,
  },
  selectAllContainer: {
    marginLeft: theme.spacing(0.5),
  },
  benefitModelName: {
    textTransform: "capitalize",
  },
  buttonBarContainer: {
    "& button": {
      marginLeft: theme.spacing(2),
    },
  },
  titleContainer: {
    "& h4": {
      marginRight: theme.spacing(1),
    },
  },
}));

export default useStyles;
